export default "__VITE_ASSET__BTA8t0Hc__"